import React from 'react';
import { TextV2, ButtonV2, useDisclosure, Flex, CheckboxV2 } from '@withjoy/joykit';
import { Filter as FilterIcon } from '@withjoy/joykit/icons';
import { useTranslation } from '@shared/core';
import { ResponsiveDialog } from '@apps/card/components/ResponsiveDialog';
import { Filter as FilterType } from '../../RecipientsPicker';

interface FilterProps {
  filters: FilterType[];
  setFilters: React.Dispatch<React.SetStateAction<FilterType[]>>;
}

const Filter: React.FC<FilterProps> = ({ filters, setFilters }) => {
  const { t } = useTranslation('guestList');
  const tAdmin = t('admin');
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <ButtonV2
        startIcon={<FilterIcon size="lg" />}
        padding={0}
        variant="ghost"
        color="mono14"
        typographyVariant="label3"
        onClick={onOpen}
        _hover={{ color: 'mono14' }}
        _active={{ color: 'mono14' }}
      />
      <ResponsiveDialog
        isOpen={isOpen}
        onClose={onClose}
        header={() => <TextV2 typographyVariant="hed3">{tAdmin.filterBy()}:</TextV2>}
        content={() => (
          <Flex flexDirection="column" alignItems="center" justifyContent="center" rowGap="24px">
            <Flex flexDirection="column" alignItems="flex-start" justifyContent="center" rowGap="12px" width="100%">
              {filters?.map(({ id, label, value }) => (
                <CheckboxV2
                  key={id}
                  isChecked={value}
                  onChange={() =>
                    setFilters(prevState => {
                      const newArray = [...prevState];
                      const index = newArray.findIndex(filter => filter.id === id);
                      if (index !== -1) {
                        newArray[index] = {
                          ...newArray[index],
                          value: !newArray[index].value
                        };
                      }
                      return newArray;
                    })
                  }
                  color="mono14"
                >
                  {label}
                </CheckboxV2>
              ))}
            </Flex>
            <ButtonV2
              padding={0}
              variant="link"
              color="mono14"
              typographyVariant="label4"
              onClick={() => setFilters(prevState => prevState.map(filter => ({ ...filter, value: false })))}
              _hover={{ color: 'mono14' }}
              _active={{ color: 'mono14' }}
            >
              {tAdmin.clearAllFilters()}
            </ButtonV2>
          </Flex>
        )}
      />
    </>
  );
};

export default Filter;
